import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "item-text" }

import {computed, onBeforeUnmount, onMounted, ref} from "vue";
import {ChevronDown, Check} from "utruckin-icons";
import {IDropdown, IDropdownOptions} from "@/types/main";


export default /*@__PURE__*/_defineComponent({
  __name: 'dropdown',
  props: {
    position: { default: 'top' },
    label: { default: "" },
    items: { default: () => [] },
    modelValue: { default: "" },
    disabled: { type: Boolean, default: false },
    width: {},
    height: {},
    additionalStyle: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isOpen = ref(false);
const rootRef = ref<HTMLElement | null>(null);

const selectedLabel = computed(() => {
  const found = props.items.find((i) => i.value === props.modelValue);
  return found?.name || "";
});

const hasSelection = computed(() => selectedLabel.value.length > 0);

function toggle() {
  if (props.disabled) return;
  isOpen.value = !isOpen.value;
}

function choose(item: IDropdown) {
  emit("update:modelValue", item.value);
  isOpen.value = false;
}

function onDocumentClick(e: MouseEvent) {
  const el = rootRef.value;
  if (!el) return;

  const target = e.target as Node | null;
  if (!target) return;

  if (!el.contains(target)) {
    isOpen.value = false;
  }
}

onMounted(() => {
  document.addEventListener("click", onDocumentClick);
});

onBeforeUnmount(() => {
  document.removeEventListener("click", onDocumentClick);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "rootRef",
    ref: rootRef,
    class: _normalizeClass(["f-ui-dropdown", {
      active: isOpen.value,
      disabled: __props.disabled,
    }]),
    onClick: toggle
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["value", { 'is-placeholder': !hasSelection.value }])
    }, _toDisplayString(selectedLabel.value || __props.label), 3),
    _createElementVNode("div", {
      class: _normalizeClass(["icon", { rotate: isOpen.value }])
    }, [
      _createVNode(_unref(ChevronDown), { size: 20 })
    ], 2),
    (isOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["list", __props.position])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "list__item",
              key: item.value || index,
              onClick: _withModifiers(($event: any) => (choose(item)), ["stop"])
            }, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(item.name), 1),
              (item.value === __props.modelValue)
                ? (_openBlock(), _createBlock(_unref(Check), {
                    key: 0,
                    class: "check"
                  }))
                : _createCommentVNode("", true)
            ], 8, _hoisted_1))
          }), 128))
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}
}

})